"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrophyOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M19.07,10.37,17.26,10,16.38,8.3c-.21-.4-.55-.4-.76,0L14.74,10l-1.81.34c-.45.08-.57.42-.26.76L14,12.53l-.25,1.94c-.06.46.22.66.63.45L16,14.07l1.66.85c.41.21.69,0,.63-.45L18,12.53l1.29-1.4C19.64,10.79,19.52,10.45,19.07,10.37Z"/><path d="M22.54,17.9c8.7-2.11,7.38-11,7.37-11.06a1,1,0,0,0-1-.84H24V5a2,2,0,0,0-2-2H10A2,2,0,0,0,8,5V6H3.08a1,1,0,0,0-1,.84c0,.09-1.33,9,7.37,11.06,1.33,2.39,3.4,4.47,5.57,5A.61.61,0,0,0,15,23v5H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2H17V23a.61.61,0,0,0,0-.13C19.14,22.37,21.22,20.28,22.54,17.9ZM28,8a7.49,7.49,0,0,1-4.41,7.45A8.42,8.42,0,0,0,24,13V8ZM4,8H8v5a8.55,8.55,0,0,0,.41,2.45A7.47,7.47,0,0,1,4,8ZM16,21c-2.31,0-6-4.37-6-8V5H22v8C22,16.64,18.31,21,16,21Z"/>';
var TrophyOutlineSVG = function TrophyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TrophyOutlineSVG = TrophyOutlineSVG;
TrophyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TrophyOutlineSVG);
exports.default = _default;